declare global {
  interface Window {
    __APP_CONFIG__?: Partial<ImportMetaEnv>;
  }
}

type RuntimeConfigKey =
  | 'VITE_API_BASE_URL'
  | 'VITE_APP_ID'
  | 'VITE_ENV'
  | 'RAW_DATA_DOWNLOAD_ENABLED';

function getRuntimeValue(key: RuntimeConfigKey): string {
  if (typeof window !== 'undefined') {
    const runtimeValue = window.__APP_CONFIG__?.[key];
    if (typeof runtimeValue === 'string' && runtimeValue.length > 0) {
      return runtimeValue;
    }
  }

  return import.meta.env[key] || '';
}

export const runtimeConfig = {
  apiBaseUrl: getRuntimeValue('VITE_API_BASE_URL'),
  appId: getRuntimeValue('VITE_APP_ID') || 'nushu-toolbox',
  env: getRuntimeValue('VITE_ENV'),
  rawDataDownloadEnabled: getRuntimeValue('RAW_DATA_DOWNLOAD_ENABLED') === 'True',
};
